import en from './en';

// English is kept as the fallback baseline; translated keys below override it.
const vi = {
  ...en,
  " · 만료됨": " · Hết hạn",
  "(password 있음)": "(đã đặt mật khẩu)",
  "(링크 없음)": "(không có liên kết)",
  "(본문 없음)": "(không có nội dung)",
  "(없음)": "(không có)",
  "(이름없음)": "(chưa đặt tên)",
  "(자동)": "(tự động)",
  "(제목 없음)": "(không có tiêu đề)",
  "+ 공지 작성": "+ Tạo thông báo",
  "+ 광고 등록": "+ Thêm quảng cáo",
  "+ 새 공지 작성": "+ Thông báo mới",
  "+ 새 광고 등록": "+ Quảng cáo mới",
  "+ 아이콘(업로드)": "+ Biểu tượng (tải lên)",
  "+ 이미지": "+ Ảnh",
  "+ 인포 버튼 추가": "+ Thêm nút thông tin",
  "+ 인포카드 추가": "+ Thêm thẻ thông tin",
  "+ 텍스트": "+ Văn bản",
  "0 이상 숫자를 입력하세요.": "Nhập số lớn hơn hoặc bằng 0.",
  "0보다 큰 금액을 입력하세요.": "Nhập số tiền lớn hơn 0.",
  "0보다 큰 숫자만 가능": "Chỉ cho phép số lớn hơn 0.",
  "24시간 반복": "Lặp lại mỗi 24 giờ",
  "2차 비밀번호(선택)": "Mật khẩu cấp 2 (tùy chọn)",
  "Country 필터": "Bộ lọc quốc gia",
  "Device 필터": "Bộ lọc thiết bị",
  "DisplaySet 날짜 필터(1일 단위)": "Bộ lọc ngày DisplaySet (đơn vị 1 ngày)",
  "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "Nhập ngày/giờ hạn hợp lệ.",
  "Due Date를 입력해야 합니다.": "Bắt buộc nhập ngày hạn.",
  "Rake % (수수료율)": "Rake % (Tỷ lệ phí)",
  "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB phải là số lớn hơn 0, tối đa 2 chữ số thập phân. Ví dụ: 0.25 / 0.50",
  "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share phải là số từ 0 đến 1 (ví dụ: 0.2).",
  "endAt은 startAt보다 늦어야 해.": "endAt phải muộn hơn startAt.",
  "message는 빈값이 될 수 없습니다.": "Tin nhắn không được để trống.",
  "message는 필수입니다.": "Bắt buộc nhập tin nhắn.",
  "⚠️ 권한이 없습니다": "⚠️ Bạn không có quyền",
  "개": "mục",
  "개 · 남은 수량": "mục · SL còn lại",
  "갱신 주기(일)": "Chu kỳ gia hạn (ngày)",
  "건": "bản ghi",
  "검색": "Tìm kiếm",
  "검색 (id / user_code / nickname / 메모)": "Tìm kiếm (id / user_code / nickname / ghi chú)",
  "검색: 이름/링크/국가": "Tìm kiếm: tên/liên kết/quốc gia",
  "검색: 제목/본문/작성자": "Tìm kiếm: tiêu đề/nội dung/người viết",
  "검색어를 입력하세요": "Nhập từ khóa tìm kiếm",
  "게시": "Đã đăng",
  "게시 상태": "Trạng thái đăng",
  "게시 중": "Đang đăng",
  "결제 영역": "Khu vực thanh toán",
  "결제 옵션": "Tùy chọn thanh toán",
  "결제 옵션 추가": "Thêm tùy chọn thanh toán",
  "결제 완료": "Thanh toán hoàn tất",
  "결제 항목": "Mục thanh toán",
  "결제관리": "Quản lý thanh toán",
  "경로": "Đường dẫn",
  "공지 관리": "Quản lý thông báo",
  "공지 본문": "Nội dung thông báo",
  "공지 수정": "Sửa thông báo",
  "공지 작성/관리": "Tạo/Quản lý thông báo",
  "공지 제목": "Tiêu đề thông báo",
  "공지가 없어. 위에서 새로 작성해줘.": "Không có thông báo. Hãy tạo mới ở trên.",
  "관리": "Quản lý",
  "관리 상태": "Trạng thái quản trị",
  "관리자 자산 표시 영역": "Khu vực tóm tắt tài sản quản trị",
  "광고 관리": "Quản lý quảng cáo",
  "광고 목록을 불러오지 못했어.": "Không tải được danh sách quảng cáo.",
  "광고 삭제에 실패했어.": "Xóa quảng cáo thất bại.",
  "광고 수정": "Sửa quảng cáo",
  "광고 이미지": "Ảnh quảng cáo",
  "광고 이미지 등록/관리": "Đăng ký/Quản lý ảnh quảng cáo",
  "광고 이미지를 업로드해줘.": "Hãy tải ảnh quảng cáo lên.",
  "광고 저장에 실패했어.": "Lưu quảng cáo thất bại.",
  "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "Nhập quốc gia. Ví dụ: KR / US / JP / ALL",
  "굵기": "Độ đậm",
  "그룹 노출(DisplaySet)": "Hiển thị nhóm (DisplaySet)",
  "그룹 미션": "Nhiệm vụ nhóm",
  "그룹 미션 설정": "Cài đặt nhiệm vụ nhóm",
  "그룹 미션 시작": "Bắt đầu nhiệm vụ nhóm",
  "그룹 생성": "Tạo nhóm",
  "그룹 시간 설정이 올바르지 않습니다.": "Cài đặt thời gian nhóm không hợp lệ.",
  "그룹 이름": "Tên nhóm",
  "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "Tên nhóm, Small Blind và Big Blind là bắt buộc. SB/BB có thể nhập như 0.25, 0.50.",
  "그룹명": "Tên nhóm",
  "글로벌": "Toàn cầu",
  "금액": "Số tiền",
  "금액은 최소 50$ 이상 부터 가능합니다.": "Số tiền tối thiểu là $50.",
  "기간": "Thời gian",
  "나의 지갑 주소": "Địa chỉ ví của tôi",
  "남미": "Nam Mỹ",
  "내부용 이름(label)": "Tên nội bộ (label)",
  "내부용 이름(label)을 입력해줘.": "Nhập tên nội bộ (label).",
  "내용(message)": "Nội dung (message)",
  "노출": "Hiển thị",
  "노출(즉시/기간무관)": "Hiển thị (ngay / không giới hạn thời gian)",
  "노출중": "Hiển thị",
  "다음": "Tiếp",
  "닫기": "Đóng",
  "데이터 없음": "Không có dữ liệu",
  "데이터가 없습니다.": "Không có dữ liệu.",
  "동남아": "Đông Nam Á",
  "동아시아": "Đông Á",
  "등록": "Đăng ký",
  "등록된 광고가 없어.": "Không có quảng cáo đã đăng ký.",
  "등록된 라운지 글이 없습니다.": "Không có bài lounge nào được đăng ký.",
  "등록된 이미지 없음": "Không có ảnh đã đăng ký",
  "라운지 관리": "Quản lý lounge",
  "라운지 글": "Bài viết lounge",
  "라운지 글 목록": "Danh sách bài lounge",
  "라운지 목록을 불러오지 못했습니다.": "Không tải được danh sách lounge.",
  "라운지 아이템": "Mục lounge",
  "라운지 업로드": "Tải lounge lên",
  "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "Lounge Point % phải là số từ 0 đến 100, tối đa 2 chữ số thập phân.",
  "라운지 포인트 지급률": "Tỷ lệ thưởng điểm lounge",
  "라운지 포인트 지급률 저장 실패": "Lưu tỷ lệ thưởng điểm lounge thất bại",
  "라운지포인트": "Điểm lounge",
  "로그아웃": "Đăng xuất",
  "로그인": "Đăng nhập",
  "로그인 실패: ": "Đăng nhập thất bại: ",
  "로딩 중...": "Đang tải...",
  "로딩중...": "Đang tải...",
  "링크 열기": "Mở liên kết",
  "링크:": "Liên kết:",
  "만료": "Hết hạn",
  "메모": "Ghi chú",
  "메인 영역": "Khu vực chính",
  "명": "người dùng",
  "무한(30일 갱신)": "Vô hạn (gia hạn 30 ngày)",
  "무한(infinite) 항목(상시 노출)": "Mục vô hạn (luôn hiển thị)",
  "무한(약 {days}일 단위 갱신)": "Vô hạn (gia hạn khoảng mỗi {days} ngày)",
  "미결제": "Chưa thanh toán",
  "미리보기": "Xem trước",
  "미션 RUN 생성 실패": "Tạo RUN nhiệm vụ thất bại",
  "미션 cfg 저장 실패": "Lưu cfg nhiệm vụ thất bại",
  "미션 상금 분배(프론트 계산)": "Phân phối giải nhiệm vụ (tính phía frontend)",
  "미션 상태 조회 실패": "Tải trạng thái nhiệm vụ thất bại",
  "받는 지갑": "Ví nhận",
  "받는쪽 (to)": "Người nhận (to)",
  "배경 색상": "Màu nền",
  "배경 이미지 URL": "URL ảnh nền",
  "배경 타입": "Loại nền",
  "보내는 지갑": "Ví gửi",
  "보낸쪽 (from)": "Người gửi (from)",
  "복사": "Sao chép",
  "복사 실패(브라우저 권한 확인)": "Sao chép thất bại (kiểm tra quyền trình duyệt)",
  "본문": "Nội dung",
  "본문 내용을 입력하세요": "Nhập nội dung",
  "본문을 입력해줘.": "Nhập nội dung.",
  "본인 {id}": "Bản thân {id}",
  "북미": "Bắc Mỹ",
  "분배 비율": "Tỷ lệ phân phối",
  "분배 비율(상대 %)": "Tỷ lệ phân phối (% tương đối)",
  "불러오기 실패": "Tải thất bại",
  "불러오는 중…": "Đang tải…",
  "비밀번호": "Mật khẩu",
  "비활성": "Tắt",
  "삭제": "Xóa",
  "삭제 실패": "Xóa thất bại",
  "삭제됨": "Đã xóa",
  "상세": "Chi tiết",
  "상시": "Luôn luôn",
  "상위 에이전트:": "Đại lý cha:",
  "상태": "Trạng thái",
  "새 공지 작성": "Tạo thông báo mới",
  "새 광고 등록": "Tạo quảng cáo mới",
  "새 전광판 등록": "Tạo bảng chạy chữ mới",
  "새로고침": "Làm mới",
  "색상": "Màu",
  "생성": "Tạo",
  "생성 중...": "Đang tạo...",
  "생성 중…": "Đang tạo…",
  "서버 오류": "Lỗi máy chủ",
  "서버로 전송될 preset 문자열(콤마 구분)": "Chuỗi preset gửi lên server (phân tách bằng dấu phẩy)",
  "세컨드 비밀번호(옵션)": "Mật khẩu cấp 2 (tùy chọn)",
  "소속 유저": "Người dùng được gán",
  "수량": "Số lượng",
  "수수료": "Phí",
  "수수료 수정": "Sửa phí",
  "수수료 수정 실패": "Sửa phí thất bại",
  "수정": "Sửa",
  "수정 모드": "Chế độ sửa",
  "시간 설정": "Cài đặt thời gian",
  "시간 설정이 올바르지 않습니다.": "Cài đặt thời gian không hợp lệ.",
  "시작": "Bắt đầu",
  "시작(로컬)": "Bắt đầu (cục bộ)",
  "시작일": "Ngày bắt đầu",
  "아래로": "Xuống",
  "아이콘 파일은 1MB 이하로 올려주세요.": "Tệp biểu tượng phải từ 1MB trở xuống.",
  "아프리카": "Châu Phi",
  "언어": "Ngôn ngữ",
  "업로드": "Tải lên",
  "업로드 URL을 받지 못했습니다.": "Chưa nhận được URL tải lên.",
  "업로드 URL을 받지 못했어.": "Chưa nhận được URL tải lên.",
  "업로드/게시": "Tải lên/Đăng",
  "업로드중...": "Đang tải lên...",
  "에이전트": "Đại lý",
  "에이전트 상금풀(": "Quỹ thưởng đại lý (",
  "에이전트로 생성": "Tạo dưới dạng đại lý",
  "예약": "Đã lên lịch",
  "예약 시간이 올바르지 않습니다.": "Thời gian lên lịch không hợp lệ.",
  "예약 없음": "Không có lịch",
  "예약/상태": "Lịch/Trạng thái",
  "오래된순": "Cũ nhất trước",
  "요소(최대 4개)": "Phần tử (tối đa 4)",
  "요청 실패 ({status})": "Yêu cầu thất bại ({status})",
  "용량": "Kích thước",
  "위로": "Lên",
  "유럽": "Châu Âu",
  "유저 관리": "Quản lý người dùng",
  "유저코드": "Mã người dùng",
  "유효 인포메이션 버튼:": "Các nút thông tin hợp lệ:",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "Bạn không có quyền truy cập trang này.",
  "이동 URL": "URL đích",
  "이미지": "Ảnh",
  "이미지 URL": "URL ảnh",
  "이미지 블록": "Khối ảnh",
  "이미지 업로드 실패: {message}": "Tải ảnh lên thất bại: {message}",
  "이미지 업로드 중...": "Đang tải ảnh lên...",
  "이미지 업로드에 실패했습니다.": "Tải ảnh lên thất bại.",
  "이미지 업로드중...": "Đang tải ảnh lên...",
  "이미지 없음": "Không có ảnh",
  "이미지 열기": "Mở ảnh",
  "이미지 파일만 등록할 수 있어.": "Chỉ có thể đăng ký tệp ảnh.",
  "이미지 파일만 업로드할 수 있어.": "Chỉ có thể tải tệp ảnh lên.",
  "이미지(URL)": "Ảnh (URL)",
  "이미지는 5MB 이하만 업로드할 수 있어.": "Ảnh phải có dung lượng từ 5MB trở xuống.",
  "이전": "Trước",
  "인포 버튼 시간 설정이 올바르지 않습니다.": "Cài đặt thời gian nút thông tin không hợp lệ.",
  "인포 버튼 프리셋 수정": "Sửa preset nút thông tin",
  "인포메이션 버튼(선택)": "Nút thông tin (tùy chọn)",
  "인포버튼 없음": "Không có nút thông tin",
  "인포버튼 프리셋 수정": "Sửa preset nút thông tin",
  "인포카드 추가": "Thêm thẻ thông tin",
  "인포카드 타이머": "Bộ đếm thẻ thông tin",
  "일": "ngày",
  "일 /": "ngày /",
  "일/": "ngày/",
  "일반 자산": "Tài sản chính",
  "임시": "Bản nháp",
  "임시저장": "Bản nháp",
  "입력값을 확인해 주세요.": "Vui lòng kiểm tra giá trị nhập.",
  "자산": "Tài sản",
  "자산 타입": "Loại tài sản",
  "자산기록": "Sổ cái tài sản",
  "작성": "Tạo",
  "작성자": "Người viết",
  "재시작": "Khởi động lại",
  "저장": "Lưu",
  "저장 중...": "Đang lưu...",
  "저장중...": "Đang lưu...",
  "적용": "Áp dụng",
  "전광판 관리": "Quản lý bảng chạy chữ",
  "전광판 등록 실패": "Tạo bảng chạy chữ thất bại",
  "전광판 목록 조회 실패": "Tải danh sách bảng chạy chữ thất bại",
  "전광판 삭제 실패": "Xóa bảng chạy chữ thất bại",
  "전광판 수정 실패": "Sửa bảng chạy chữ thất bại",
  "전체": "Tất cả",
  "전체 상태": "Trạng thái tổng thể",
  "접기": "Thu gọn",
  "정렬": "Sắp xếp",
  "정렬 변경에 실패했어.": "Thay đổi thứ tự thất bại.",
  "정렬 저장": "Lưu thứ tự",
  "정렬 저장 실패": "Lưu thứ tự thất bại",
  "정보 수정 실패": "Sửa thông tin thất bại",
  "정보수정": "Sửa thông tin",
  "정상": "Bình thường",
  "제거": "Gỡ bỏ",
  "제목": "Tiêu đề",
  "제목을 입력하세요": "Nhập tiêu đề",
  "제목을 입력해줘.": "Nhập tiêu đề.",
  "조회": "Tìm kiếm",
  "종료(로컬)": "Kết thúc (cục bộ)",
  "종료일": "Ngày kết thúc",
  "중동": "Trung Đông",
  "중앙아시아": "Trung Á",
  "중지": "Dừng",
  "지갑 주소": "Địa chỉ ví",
  "지금": "Bây giờ",
  "지급": "Cộng tiền",
  "지급 실패": "Cộng tiền thất bại",
  "차감": "Trừ tiền",
  "차감 실패": "Trừ tiền thất bại",
  "차단": "Chặn",
  "차단 해제": "Bỏ chặn",
  "차단됨": "Đã chặn",
  "처리 중...": "Đang xử lý...",
  "초기화": "Đặt lại",
  "초안": "Bản nháp",
  "총 상금풀(1.5%):": "Tổng quỹ thưởng (1,5%):",
  "총베팅액:": "Tổng cược:",
  "최근순": "Mới nhất trước",
  "출금하기": "Rút tiền",
  "충전 하기": "Nạp tiền",
  "취소": "Hủy",
  "카테고리": "Danh mục",
  "크기(px)": "Kích thước (px)",
  "클릭 시 출금이 시작 됩니다.": "Rút tiền sẽ bắt đầu khi nhấp.",
  "클릭 이동 URL(link_url)": "URL nhấp chuyển (link_url)",
  "클릭 이동 링크(URL)": "Liên kết nhấp chuyển (URL)",
  "클릭하면 등록 모달": "Nhấp để mở modal đăng ký",
  "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "Nhấp để đặt thời gian tham chiếu hiển thị thành ngày này.",
  "클릭하여 이미지 업로드": "Nhấp để tải ảnh lên",
  "타이머 없음": "Không có bộ đếm",
  "타이머 타입": "Loại bộ đếm",
  "타이머(존재유무만)": "Bộ đếm (chỉ có/không)",
  "타이머는": "Bộ đếm là",
  "타입": "Loại",
  "테이블 관리": "Quản lý bàn",
  "테이블 그룹 목록 조회 실패": "Tải danh sách nhóm bàn thất bại",
  "테이블 그룹 생성 실패": "Tạo nhóm bàn thất bại",
  "테이블 그룹 생성 완료": "Tạo nhóm bàn thành công",
  "테이블 그룹 코드 생성 실패": "Tạo mã nhóm bàn thất bại",
  "테이블 그룹이 없습니다.": "Không có nhóm bàn.",
  "테이블 미션": "Nhiệm vụ bàn",
  "테이블 미션 RUN 생성 실패": "Tạo RUN nhiệm vụ bàn thất bại",
  "테이블 미션 RUN 중지 실패": "Dừng RUN nhiệm vụ bàn thất bại",
  "테이블 미션 cfg 저장 실패": "Lưu cfg nhiệm vụ bàn thất bại",
  "테이블 미션 상금 분배(프론트 계산)": "Phân phối giải nhiệm vụ bàn (tính phía frontend)",
  "테이블 미션 상태 조회 실패": "Tải trạng thái nhiệm vụ bàn thất bại",
  "텍스트": "Văn bản",
  "텍스트 블록": "Khối văn bản",
  "텍스트 스타일": "Kiểu văn bản",
  "파일명": "Tên tệp",
  "판매": "Đã bán",
  "페이지": "Trang",
  "페이지 크기": "Kích thước trang",
  "펼치기": "Mở rộng",
  "폰트스타일": "Kiểu phông chữ",
  "표시 기준 시간": "Thời gian tham chiếu hiển thị",
  "표시 순서(order)": "Thứ tự hiển thị (order)",
  "표시 여부만": "Chỉ trạng thái hiển thị",
  "표시명": "Tên hiển thị",
  "표시할 기록이 없습니다.": "Không có bản ghi để hiển thị.",
  "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "Test frontend: xử lý hoàn tất chuyển tiền (trước khi kết nối backend)",
  "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "Test frontend: xử lý bắt đầu rút tiền (trước khi kết nối backend)",
  "프리셋 수정": "Sửa preset",
  "프리셋(배경/요소/URL)": "Preset (nền/phần tử/URL)",
  "플레이어 상금풀(": "Quỹ thưởng người chơi (",
  "플레이어 수수료 설정": "Cài đặt phí người chơi",
  "하위": "Cấp dưới",
  "하위 {id}": "Cấp dưới {id}",
  "하위 계정 생성": "Tạo tài khoản cấp dưới",
  "하위 생성": "Tạo cấp dưới",
  "하위 생성 (부모:": "Tạo cấp dưới (Cha:",
  "하이라이트 메세지": "Thông điệp nổi bật",
  "하이라이트 포인트": "Điểm nổi bật",
  "현재 라운지 포인트 %": "Lounge Point % hiện tại",
  "확인용 테스트 거래 시작": "Bắt đầu giao dịch thử",
  "활성 RUN이 없습니다.": "Không có RUN đang hoạt động.",
  "회원 정보 수정": "Sửa thông tin thành viên",
  "🔐 어드민 로그인": "🔐 Đăng nhập quản trị",
};

export default vi;
